import {
  BasketItem,
  BasketRow,
  GuestCartResponse,
  RawGuestCart,
} from '../types/basket';

function buildGuestCartUrl(cartId: string, guestCartEndpoint?: string): string {
  const base = (guestCartEndpoint ?? '').trim();
  const url = new URL(base);
  url.searchParams.set('cartId', cartId);
  return url.toString();
}

function coerceNumber(v: unknown): number | undefined {
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  if (typeof v === 'string') {
    const n = Number(v);
    if (Number.isFinite(n)) return n;
  }
  return undefined;
}

function normaliseFromBasketItems(raw: unknown): BasketItem[] {
  const list = (raw as RawGuestCart)?.data?.basketItems;
  if (!Array.isArray(list)) return [];

  return (list as unknown[]).map((row, idx): BasketItem => {
    const r = row as BasketRow;

    const p = r.product ?? {};
    const title = p.displayName ?? p.name ?? r.productTitle ?? 'Item';

    const imageUrl = p.imageUrl ?? r.productImage;
    const quantity = r.quantity ?? 1;

    const firstPrice = coerceNumber(
      p.price?.[0]?.recurringDiscountedPrice ??
        p.price?.[0]?.recurringPrice ??
        r.price?.[0]?.recurringDiscountedPrice ??
        r.price?.[0]?.recurringPrice,
    );

    return {
      id: String(p.id ?? r.productId ?? idx),
      title,
      imageUrl,
      quantity,
      price: firstPrice,
      inStock: true,
    };
  });
}

export async function fetchGuestCart(
  cartId: string,
  guestCartEndpoint?: string,
): Promise<GuestCartResponse> {
  const cartURL = buildGuestCartUrl(cartId, guestCartEndpoint);
  const res = await fetch(cartURL, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'include',
    mode: 'cors',
  });

  if (!res.ok) throw new Error(`Guest cart fetch failed (${res.status})`);

  const raw: unknown = await res.json().catch<unknown>(() => ({}));
  return { raw, items: normaliseFromBasketItems(raw) };
}
